<template>
    <div>
        <div class="text-right ml-auto mb-4" style="position: sticky; top: 0px; z-index: 99; width: fit-content">
            <button class="btn btn-common-cancel mr-3" @click="handleCancel">{{ $t('btn.cancel') }}</button>
            <button class="btn btn-common btn-success" @click="handleSave">{{ $t('btn.save') }}</button>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                >{{ $t('landingPage.settingButtonBlock.titleBlock') }} <span class="text-danger">*</span></label
            >
            <div class="col-sm-8">
                <InputText
                    :model.sync="dataFormTitle.title_block"
                    :config.sync="configFormTitleButton.configFieldTitle"
                    @blur="handleValidateField(configFormTitleButton.configFieldTitle)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.titleButton') }} </label>
            <div class="col-sm-8">
                <InputText
                    :model.sync="dataFormTitle.title_button"
                    :config.sync="configFormTitleButton.configFieldTitleButton"
                    @blur="handleValidateField(configFormTitleButton.configFieldTitleButton)"
                    @change="onHandleTranferShotCode"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.link') }} </label>
            <div class="col-sm-8">
                <InputText
                    :model.sync="dataFormTitle.url"
                    :config.sync="configFormTitleButton.configFieldLink"
                    @blur="handleValidateField(configFormTitleButton.configFieldLink)"
                    @change="onHandleTranferShotCode"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.style') }} </label>
            <div class="col-sm-8">
                <div class="d-flex flex-wrap" style="gap: 1rem">
                    <div v-for="item in LIST_STYLE_BUTTON_BLOCK" :key="item.id + 's'">
                        <InputRadio
                            class="mr-4"
                            :model.sync="dataFormTitle.style"
                            :name="`block_button-style`"
                            :id="`block_button-style-${item.id}`"
                            :value="item"
                            :label="item.name"
                            @change="onHandleTranferShotCode('select')"
                        />
                        <div class="mt-2" style="width: 100px; height: 80px">
                            <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.backgroundColor') }} </label>
            <div class="col-sm-5" style="min-width: 120px">
                <div class="d-flex" style="gap: 1rem">
                    <InputText
                        style="min-width: 100px"
                        :model.sync="dataFormTitle.background_color"
                        :config.sync="configFormTitleButton.configFieldColor"
                        @blur="handleValidateField(configFormTitleButton.configFieldColor)"
                        @change="onHandleTranferShotCode"
                    />
                    <InputText
                        style="max-width: 100px"
                        :model.sync="dataFormTitle.background_color"
                        :config="{
                            error: false
                        }"
                        @change="onHandleTranferShotCode"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.colorText') }} </label>
            <div class="col-sm-5" style="min-width: 120px">
                <div class="d-flex" style="gap: 1rem">
                    <InputText
                        style="min-width: 100px"
                        :model.sync="dataFormTitle.color"
                        :config.sync="configFormTitleButton.configFieldColor"
                        @blur="handleValidateField(configFormTitleButton.configFieldColor)"
                        @change="onHandleTranferShotCode"
                    />
                    <InputText
                        style="max-width: 100px"
                        :model.sync="dataFormTitle.color"
                        :config="{
                            error: false
                        }"
                        @change="onHandleTranferShotCode"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingButtonBlock.attribute') }} </label>
            <div class="col-sm-3">
                <Multiselect
                    :id="`select-block_button-font-${dataFormTitle?.id}`"
                    :value.sync="dataFormTitle.font_button"
                    :options="LIST_FONT_PAGE"
                    :config="{ error: false, isRemove: true, loading: false, trackBy: 'id', label: 'name' }"
                    @select="onHandleTranferShotCode"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { configFormTitleButton } from '../constants';
import { InputText, InputRadio } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate';
import { LIST_STYLE_BUTTON_BLOCK } from '../../../styles';
import { LIST_FONT_PAGE } from '../../../constants';
import { tranferShortCode } from '@/utils/format';
import { onHandleChangeTemp, mapImageDefault } from '../../../handlers';

import Multiselect from '@/components/Multiselect/main.vue';

export default {
    name: 'ActionButtonBlock',
    components: {
        InputText,
        InputRadio,
        Multiselect
    },
    props: {
        dataButtonBlock: {
            type: Array,
            default: () => []
        },
        objButton: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage'])
        })
    },
    data() {
        return {
            configFormTitleButton: configFormTitleButton,
            LIST_STYLE_BUTTON_BLOCK: mapImageDefault(LIST_STYLE_BUTTON_BLOCK),
            LIST_FONT_PAGE: LIST_FONT_PAGE,
            dataFormTitle: this.initButton()
        };
    },
    methods: {
        initButton() {
            return {
                key_parent: '',
                title_block: '',
                title_button: '',
                url: '',
                style: null,
                background_color: '',
                color: '',
                font_button: null,
                html_content: ''
            };
        },
        handleValidateField(configField) {
            validateField(configField);
        },
        handleCancel() {
            let { configFieldTitle, configFieldTitleButton, configFieldLink } = this.configFormTitleButton;
            configFieldTitleButton.error = configFieldLink.error = configFieldTitle.error = false;
            this.$emit('cancel');
        },

        handleSave() {
            let checkValidate = validateAllField(configFormTitleButton);
            if (!checkValidate) return;
            this.$emit('save', this.dataFormTitle);
        },

        onHandleTypeButton() {
            this.onHandleTranferShotCode();
        },

        onHandleTranferShotCode(type = null) {
            let { title_button, url, style, color, font_button } = this.dataFormTitle;
            if (type === 'select') this.dataFormTitle.background_color = this.dataFormTitle?.style?.backgroundColorDefault ?? '#6dcabf';
            if (type === 'select') this.dataFormTitle.color = this.dataFormTitle?.style?.colorDefault ?? '#6dcabf';
            const replacements = {
                titleButton: title_button ?? '',
                URL: url ? url : '#',
                backgroundColor: this.dataFormTitle.background_color ?? '#ffffff',
                color: color ?? '#ffffff',
                fontFamily: font_button?.property_style?.fontFamily ?? ''
            };
            let contentShotCode = tranferShortCode(style?.contents, replacements);
            this.dataFormTitle.html_content = `<div class="block_button">
                ${contentShotCode}
                </div
            `;
        }
    },
    watch: {
        objButton: {
            handler: function (newObj) {
                let { key_parent, name, color, title_button, background_color } = newObj;
                const foundObj = this.dataButtonBlock?.find((otp) => otp.key_parent === key_parent);
                if (foundObj) {
                    this.dataFormTitle = {
                        ...this.dataFormTitle,
                        ...foundObj
                    };
                } else {
                    this.dataFormTitle = {
                        ...this.dataFormTitle,
                        title_block: name,
                        title_button: title_button ?? 'ご応募はこちら',
                        key_parent,
                        color: color ?? '#ffffff',
                        background_color: background_color ?? '#6dcabf'
                    };
                }
            },
            immediate: true
        }
    },
    mounted() {
        let { style } = this.dataFormTitle;
        if (style) return;
        let checkTem = onHandleChangeTemp(this.infoSettingLandingPage, this.dataFormTitle, this.LIST_STYLE_BUTTON_BLOCK);
        if (checkTem) this.onHandleTranferShotCode('select');
    }
};
</script>

<style lang="scss" scoped></style>
